import css_4qt11joumwc from './css/AdCompanionAd.css';
import Div from './Div.js';
import AdCompanionClose from './AdCompanionClose.js';
import Iframe from './Iframe.js';

const css = css_4qt11joumwc;

export default class AdCompanionAd extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
		this.close = new AdCompanionClose(this);
		this.content = new Iframe(this,'Companion Ad');
		this.content.element.contentDocument.open();
		this.content.element.contentDocument.close();
		this.content.element.className = 'content';
		this.content.bodyElement.style.margin = '0';
		this.element.classList.add('empty');
	}

	clear()
	{
		this.content.bodyElement.innerHTML = '';
		this.element.classList.add('empty');
	}

	setFromAd(imaAd)
	{
		const settings = google.ima['CompanionAdSelectionSettings'];
		const selectionCriteria = new settings();
		selectionCriteria.resourceType = settings['ResourceType']['STATIC'];
		selectionCriteria.creativeType = settings['CreativeType']['IMAGE'];
		selectionCriteria.sizeCriteria = settings['SizeCriteria']['SELECT_NEAR_MATCH'];
		try
		{
			// Get a list of companion ads for an ad slot size and CompanionAdSelectionSettings
			const companionAds = imaAd && imaAd['getCompanionAds'](300, 60, selectionCriteria);
			// Write the content to the companion ad slot.
			const content = companionAds && companionAds[0] && companionAds[0].getContent() || '';
			if(content)
			{
				this.content.bodyElement.innerHTML = content;
				this.element.classList.remove('empty');
			}
		}
		catch(e)
		{

		}
	}

	get cssText()
	{
		return css;
	}
}